// Web adapter for the mobile crypto bundle's `api` import.
// Contract (per cl-readme): api(path, { method?, body? }) -> parsed JSON, throws on non-2xx,
// sends Authorization: Bearer <token>. Reuses the app's axios client (baseURL = `${BACKEND}/api`).
import { client } from "@/lib/api";

export async function api(path, opts = {}) {
  const method = (opts.method || "GET").toLowerCase();
  const res = await client.request({ url: path, method, data: opts.body });
  return res.data;
}

export default api;
